var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.487,
    height: 16,
    viewBox: "0 0 20.487 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Vehicles_",
    "data-name": " Vehicles ",
    d: "M205.473,235.229v3.838a.291.291,0,0,1-.31.31H204.2v1.27a1.919,1.919,0,0,1-3.838,0v-1.27H190.094v1.27a1.919,1.919,0,0,1-3.838,0v-1.27H185.3a.291.291,0,0,1-.31-.31v-3.838A2.216,2.216,0,0,1,187.215,233l1.326-4.2a3.022,3.022,0,0,1,2.85-2.229h7.7a3.021,3.021,0,0,1,2.85,2.229l1.326,4.2a2.173,2.173,0,0,1,1.58.649,2.315,2.315,0,0,1,.621,1.58Zm-16.2,2.116a1.568,1.568,0,0,0,0-2.257,1.568,1.568,0,0,0-2.257,0,1.608,1.608,0,0,0,1.129,2.737A1.651,1.651,0,0,0,189.275,237.346Zm1.75-4.374h8.352a.727.727,0,0,0,.706-.9l-.677-2.681c0-.056-.056-.113-.141-.169a.376.376,0,0,0-.2-.085h-7.7a.305.305,0,0,0-.2.085.377.377,0,0,0-.141.169l-.677,2.681a.713.713,0,0,0,.677.9Zm12.36,4.374a1.608,1.608,0,1,0-2.257,0,1.582,1.582,0,0,0,1.129.48A1.707,1.707,0,0,0,203.385,237.346Z",
    transform: "translate(-184.986 -226.566)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicles);
export default __webpack_public_path__ + "static/media/vehicles.85fe4e436f66a2285b31eeba03a755c2.svg";
export { ForwardRef as ReactComponent };